import { Component, Input, Output, EventEmitter } from '@angular/core';
import { format } from 'date-fns';

@Component({
  selector: 'summary-date-picker',
  templateUrl: './summary-date-picker.component.html',
})
export class SummaryDatePickerComponent{
  @Input() startDate;
  @Input() endDate;
  @Output() selectedDateRange = new EventEmitter();

  private date:string = 'yyyy-MM-dd';


  public selectDate(event){
    const date = { ...event.detail };

    if(date.startDate && date.endDate){
      date.startDate = format(date.startDate, this.date);
      date.endDate = format(date.endDate, this.date);
    }
    this.selectedDateRange.emit(date)
  }
}

